(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colossal-results"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initColossalResults = (section) => {
    if (!section || section.dataset.colossalResultsInitialized === "true") return;

    const track = section.querySelector(".colossal-results-track");
    const cards = Array.from(section.querySelectorAll(".colossal-result-card"));
    const dots = Array.from(section.querySelectorAll(".colossal-result-dots button"));

    if (!track || !cards.length || !dots.length) return;

    section.dataset.colossalResultsInitialized = "true";

    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle("active", active);
        if (active) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    };

    const goTo = (index) => {
      const target = cards[index];
      if (target) track.scrollTo({ left: target.offsetLeft, behavior: "smooth" });
      setActive(index);
    };

    const onScroll = () => {
      const nearest = cards.reduce((best, card, index) => {
        const distance = Math.abs(card.offsetLeft - track.scrollLeft);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Number.POSITIVE_INFINITY });
      setActive(nearest.index);
    };

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => goTo(index));
    });

    track.addEventListener("scroll", onScroll);
    setActive(0);
  };

  const initAllColossalResults = (root = document) => {
    if (root.matches && root.matches(".colossal-results")) initColossalResults(root);
    root.querySelectorAll(".colossal-results").forEach(initColossalResults);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllColossalResults());
  } else {
    initAllColossalResults();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAllColossalResults(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kf-routine"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initKfRoutine = (section) => {
    if (!section || section.dataset.kfRoutineInitialized === "true") return;

    const rail = section.querySelector(".kf-rail");
    const slides = rail ? Array.from(rail.children) : [];
    const dots = Array.from(section.querySelectorAll(".kf-dots button"));

    if (!rail || !slides.length || !dots.length) return;

    section.dataset.kfRoutineInitialized = "true";

    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    };

    const getPadding = () => parseFloat(getComputedStyle(rail).paddingLeft) || 0;

    const goTo = (index) => {
      const targetIndex = (index + slides.length) % slides.length;
      const target = slides[targetIndex];
      rail.scrollTo({
        left: target.offsetLeft - getPadding(),
        behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth"
      });
      setActive(targetIndex);
    };

    const onScroll = () => {
      const padding = getPadding();
      const active = slides.reduce((best, slide, index) => {
        const distance = Math.abs(slide.offsetLeft - padding - rail.scrollLeft);
        const bestDistance = Math.abs(slides[best].offsetLeft - padding - rail.scrollLeft);
        return distance < bestDistance ? index : best;
      }, 0);
      setActive(active);
    };

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => goTo(index));
    });

    rail.addEventListener("scroll", onScroll);

    setActive(0);
  };

  const initAllKfRoutines = (root = document) => {
    if (root.matches && root.matches(".kf-routine")) initKfRoutine(root);
    root.querySelectorAll(".kf-routine").forEach(initKfRoutine);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllKfRoutines());
  } else {
    initAllKfRoutines();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAllKfRoutines(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kit-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initKitCarousel = (carousel) => {
    if (!carousel || carousel.dataset.kitCarouselInitialized === "true") return;

    const rail = carousel.querySelector(".kit-carousel-rail");
    const slides = Array.from(carousel.querySelectorAll(".kit-slide"));
    const dots = Array.from(carousel.querySelectorAll(".kit-carousel-dots button"));

    if (!rail || !slides.length || !dots.length) return;

    carousel.dataset.kitCarouselInitialized = "true";

    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => {
        if (dotIndex === index) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    };

    const goTo = (index) => {
      const next = (index + slides.length) % slides.length;
      rail.scrollTo({ left: next * rail.clientWidth, behavior: "smooth" });
      setActive(next);
    };

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => goTo(index));
    });

    rail.addEventListener("scroll", () => {
      setActive(Math.round(rail.scrollLeft / rail.clientWidth));
    });

    setActive(0);
  };

  const initAllKitCarousels = (root = document) => {
    if (root.matches && root.matches(".kit-carousel")) initKitCarousel(root);
    root.querySelectorAll(".kit-carousel").forEach(initKitCarousel);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initAllKitCarousels());
  } else {
    initAllKitCarousels();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initAllKitCarousels(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-ingredient-story"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initializeVideo = (container) => {
    if (!container || container.dataset.ingredientVideoInitialized === "true") return;

    const video = container.querySelector("video");
    const button = container.querySelector("button");

    if (!video || !button) return;

    container.dataset.ingredientVideoInitialized = "true";

    const setPlaying = () => {
      container.classList.add("is-playing");
      video.controls = true;
      button.remove();
    };

    video.addEventListener("play", setPlaying, { once: true });

    button.addEventListener("click", () => {
      setPlaying();
      void video.play();
    });
  };

  const initializeVideos = (root = document) => {
    if (root.matches && root.matches(".pdp-ingredient-story-video")) initializeVideo(root);
    root.querySelectorAll(".pdp-ingredient-story-video").forEach(initializeVideo);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeVideos());
  } else {
    initializeVideos();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeVideos(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-serum-carousel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initializeCarousel = (section) => {
    if (!section || section.dataset.serumCarouselInitialized === "true") return;

    const rail = section.querySelector(".pdp-serum-carousel-rail");
    const cards = rail ? Array.from(rail.children) : [];
    const dots = Array.from(section.querySelectorAll(".pdp-serum-carousel-dots button"));

    if (!rail || !cards.length || !dots.length) return;

    section.dataset.serumCarouselInitialized = "true";

    const setActiveSlide = (index) => {
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle("is-active", active);
        if (active) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    };

    const updateActiveSlide = () => {
      const nearest = cards.reduce((best, card, index) => {
        const distance = Math.abs(card.offsetLeft - rail.offsetLeft - rail.scrollLeft);
        return distance < best.distance ? { index, distance } : best;
      }, { index: 0, distance: Number.POSITIVE_INFINITY });

      setActiveSlide(nearest.index);
    };

    rail.addEventListener("scroll", updateActiveSlide);

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        const card = cards[index];
        if (!card) return;

        rail.scrollTo({
          left: card.offsetLeft - rail.offsetLeft,
          behavior: "smooth"
        });
      });
    });

    setActiveSlide(0);
  };

  const initializeCarousels = (root = document) => {
    if (root.matches && root.matches(".pdp-serum-carousel")) initializeCarousel(root);
    root.querySelectorAll(".pdp-serum-carousel").forEach(initializeCarousel);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initializeCarousels());
  } else {
    initializeCarousels();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeCarousels(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-story-image-led"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initStoryCarousel = (carousel) => {
    if (!carousel || carousel.dataset.storyCarouselInitialized === "true") return;

    const rail = carousel.querySelector(".curl-comb-story-rail");
    const cards = Array.from(carousel.querySelectorAll(".curl-comb-story-card"));
    const dots = Array.from(carousel.querySelectorAll(".curl-comb-story-dots button"));

    if (!rail || !cards.length || !dots.length) return;

    carousel.dataset.storyCarouselInitialized = "true";

    const setActive = (index) => {
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle("active", active);
        if (active) {
          dot.setAttribute("aria-current", "true");
        } else {
          dot.removeAttribute("aria-current");
        }
      });
    };

    dots.forEach((dot, index) => {
      dot.addEventListener("click", () => {
        rail.scrollTo({ left: index * rail.clientWidth, behavior: "smooth" });
        setActive(index);
      });
    });

    rail.addEventListener("scroll", () => {
      setActive(Math.round(rail.scrollLeft / rail.clientWidth));
    });

    setActive(0);
  };

  const initStoryCarousels = (root = document) => {
    if (root.matches && root.matches(".curl-comb-story-carousel")) initStoryCarousel(root);
    root.querySelectorAll(".curl-comb-story-carousel").forEach(initStoryCarousel);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initStoryCarousels());
  } else {
    initStoryCarousels();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initStoryCarousels(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
